var _circle, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalDataCollected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#6A01FE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.7646,
    y: 11.7646,
    width: 26.4706,
    height: 26.4706,
    rx: 4.61539,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.7692,
    y: 13.8008,
    width: 3.39367,
    height: 22.3982,
    rx: 1.69683,
    fill: "#6A01FE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.837,
    y: 23.3027,
    width: 3.39367,
    height: 12.8959,
    rx: 1.69683,
    fill: "#6A01FE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.303,
    y: 19.2305,
    width: 3.39367,
    height: 16.9683,
    rx: 1.69683,
    fill: "#6A01FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalDataCollected);
export default __webpack_public_path__ + "static/media/total-data-collected.97a1d07cb4e3a29bbc28f2e3299215ff.svg";
export { ForwardRef as ReactComponent };